import {
  POST_ROUTES_CATALOG,
  POST_ROUTES_CATALOG_SUCCESS,
  POST_ROUTES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postRoutesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case POST_ROUTES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_ROUTES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_ROUTES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
